import { lazy } from "react";

const CallRecentVisitPage = lazy(() => import("./pages/CallRecentVisitPage"));

export const callRecentVisitRoutes = [
  { path: "/call-recent-visit", element: <CallRecentVisitPage /> },
];
